import { Pagination } from '../../../../../../models/pagination-table.model';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ITransporterMember } from '../../../../../../models/transporter-member.model';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { TranslateService } from '@ngx-translate/core';
import { ITransporterGroup } from '../../../../../../models/transporter-group.model';
import { TransporterGroupService } from '../../../../../../services/transporterGroup.service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';

@Component({
  selector: 'jhi-transporter-groups-list',
  templateUrl: './transporter-groups-list.component.html',
  styleUrls: ['./transporter-groups-list.component.scss'],
})
export class TransporterGroupsListComponent {
  protected readonly modalService = inject(BaryModalService);
  protected readonly translateService = inject(TranslateService);
  protected readonly transporterGroupService = inject(TransporterGroupService);

  @Input() transporterGroups?: ITransporterGroup[];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();

  protected readonly PATHS = PATHS;

  trackId(index: number, item: ITransporterMember): number {
    return item.id!;
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  delete(transporterGroup: ITransporterGroup): void {
    const message = this.translateService.instant('transporterMember.delete.group.middle.question', {
      name: transporterGroup.name,
    });
    this.modalService
      .openConfirm(message)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.transporterGroupService.delete(transporterGroup.id!).subscribe(() => {
            this.transition();
          });
        }
      });
  }
}
